import { render, staticRenderFns } from "./ParamTipoPropriedade.vue?vue&type=template&id=30e729d0"
import script from "./ParamTipoPropriedade.vue?vue&type=script&lang=js"
export * from "./ParamTipoPropriedade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports